import { Fragment, useEffect, useState } from "react";
import styles from "./HighlightText.module.css";

interface Props {
  text: string;
  highlight: string;
  className?: string;
}

const HighlightText = ({ text, highlight, className }: Props) => {
  const [parts, setParts] = useState<string[]>([]);

  useEffect(
    () =>
      setParts(text.split(new RegExp(`(${escapeRegExp(highlight)})`, "gi"))),
    [text, highlight],
  );

  return (
    <span className={className}>
      {parts.map((part, index) => (
        <Fragment key={index}>
          {part.toLowerCase() === highlight.toLowerCase() ? (
            <span className={styles.highlighted}>{part}</span>
          ) : (
            part
          )}
        </Fragment>
      ))}
    </span>
  );
};

const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export default HighlightText;
